import { Route } from 'kts-platform-frame/routes';
import apps from 'src/display/apps';
import platform from 'src/display/platform';
import UIIframe from './UI.Iframe';
import UIAppContainer from './UI.AppContainer';

const parentName: string = 'workbench'; // 路由的跟节点；

Route.addNode(
    parentName,
    { nodeName: 'workbench/app', path: '/workbench/app/:appKey', component: UIIframe },
    { nodeName: 'workbench/m', path: '/workbench/m/:appKey', component: UIAppContainer },
    
    { nodeName: 'workbench/invoiceInput', path: '/workbench/invoiceInput', title: '发票录入' , component: apps.InvoiceInput },
    { nodeName: 'workbench/invoiceManage', path: '/workbench/invoiceManage', title: '发票管理' , component: apps.InvoiceManage },
    { nodeName: 'workbench/OutputSettlement', path: '/workbench/OutputSettlement', title: '销项结算单' , component: apps.OutputSettlement },
    { nodeName: 'workbench/text', path: '/workbench/inputSettlement', title: '进项结算单' , component: apps.InputSettlement },
    { nodeName: 'workbench/auth', path: '/workbench/authManage', title: '勾选认证' , component: apps.AuthManage },
    { nodeName: 'workbench/invoiceCompare', path: '/workbench/invoiceCompare', title: '发票比对' , component: apps.InvoiceCompare },
    { nodeName: '/workbench/platform/network', path: '/workbench/platform/network', title: '网络' , component: platform.Network },
    { nodeName: '/workbench/platform', path: '/workbench/platform', title: '用户中心' , component: platform.UserCenter },
    { nodeName: '/workbench/platform/inBox', path: '/workbench/platform/inBox', title: '收件箱' , component: platform.InBox },
    { nodeName: '/workbench/platform/companyInfo', path: '/workbench/platform/companyinfo', title: '公司信息', component: platform.CompanyInfo },
    { nodeName: '/workbench/platform/appStore', path: '/workbench/platform/appStore', title: 'app应用', component: platform.AppStore },
    { nodeName: '/workbench/platform/help', path: '/workbench/platform/help', title: '帮助中心', component: platform.HelpCenter },
    { nodeName: '/workbench/platform/organization', path: '/workbench/platform/organization', title: '部门管理', component: platform.Organization },
    { nodeName: '/workbench/platform/document', path: '/workbench/platform/document', title: '单据', component: platform.Document },
    { nodeName: '/workbench/platform/userManage', path: '/workbench/platform/usermanage', title: '用户管理', component: platform.UserMange },
    // { nodeName: '/workbench/platform/gettingStarted', path: '/workbench/platform/gettingStarted', title: '引导页', component: platform.GettingStarted },
    { nodeName: '/workbench/platform/groupInfo', path: '/workbench/platform/groupInfo', component: apps.GroupInfo },
    { nodeName: '/workbench/myApp', path: '/workbench/myApp', title: '我的应用', component: require('src/display/platform/MyApp').default },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
};

export {
    Switch
} from 'react-router-dom';



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/Modules.Route.tsx